<template>
  <lr-dialog
    :dialogTitle="dialogTitle"
    :dialogVisible.sync="dialogVisible"
    :width="width"
    :destroyOnClose="true"
    @cancel="cancel"
    @diaLogSubmit="diaLogSubmit"
  >
    <div class="container">
      <!-- <div class="container-left"><auth-dept-tree :width="treeWidth" @setTreeWidth="setTreeWidth" @nodeClick="deptClick" :needLoad="false" ></auth-dept-tree></div> -->

      <div class="container-left">
        <dept-tree
          :width="treeWidth"
          @setTreeWidth="setTreeWidth"
          @nodeClick="deptClick"
          :DeptType="1"
          :WebsiteID="currentWebSiteID"
        >
        </dept-tree>
      </div>
      <div class="container-middle">
        <lr-crud
          ref="crud"
          @loadData="loadData"
          :tableData="tableData"
          :options="tableOptions"
          :pages="pages"
          @select="select"
          @selectAll="select"
        >
          <template #headerBtnLeft>
            <el-button @click="addRoles" type="primary">选择用户</el-button>
          </template>
        </lr-crud>
      </div>
      <div class="container-right">
        <lr-crud
          ref="checkedCrud"
          :tableData="checkedCrudData"
          :options="checkedCrudOptions"
          @select="removeSelect"
          @selectAll="removeSelect"
        >
          <template #headerBtnLeft>
            <el-button @click="removeRoles" type="primary">移除用户</el-button>
          </template>
        </lr-crud>
      </div>
    </div>
  </lr-dialog>
</template>

<script>
import { getUserList } from "@/areas/systemmanage/api/user";
import LeftRoleType from "@/areas/systemmanage/views/role/components/LeftRoleType";
import { unique } from "@/utils/index.js";
export default {
  name: "UserSelect",
  components: {
    LeftRoleType,
  },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    currentWebSiteID: {
      type: String,
      default: "",
    },
  },
  computed: {
    tableOptions() {
      let tableOptions = {
        selection: true,
        index: true,
        queryBtn: false,
        loading: false,
        autoQuery: false,
        advanceSearchDefaultColsVisiable: false,
        column: [
          { label: "姓名", field: "DisplayName" },
          { label: "登录名", field: "LoginName" },
          { label: "工号", field: "AgentNo" },
          { label: "部门", field: "DeptName" },
          { label: "职位", field: "JobTitle" },
        ],
        height: "auto",
        pagination: true,
        hideCheckAll: !this.multiple,
      };
      return tableOptions;
    },
  },
  mounted() {},
  data() {
    return {
      dialogVisible: true,
      dialogTitle: "添加列表",
      width: "1000px",
      checkedCrudData: [],
      checkedCrudOptions: {
        selection: true,
        queryBtn: false,
        column: [
          { label: "姓名", field: "DisplayName" },
          //{ label: "登录名", field: "LoginName",},
        ],
        height: "auto",
        pagination: false,
      },
      tableData: [],

      pages: {
        PageIndex: 1,
        PageSize: 10,
        total: 0,
      },
      currentTreeId: "",
      checkedData: [],
      removeData: [],
      treeWidth: "200px",
    };
  },
  methods: {
    removeRoles() {
      if (this.removeData.length == 0) {
        this.$warningMessage("请选择需要移除的用户");
      } else {
        this.removeData.map((item, index) => {
          this.checkedCrudData.map((j, k) => {
            if (j.ID == item.ID) {
              this.checkedCrudData.splice(k, 1);
            }
          });
        });
      }
      this.removeData = [];
      this.$refs.checkedCrud.clearSelection();
    },
    addRoles() {
      if (this.checkedData.length == 0) {
        this.$warningMessage("请选择需要增加的用户");
      } else {
        let newArr = [];
        if (!this.multiple) {
          newArr = [...this.checkedData, ...[]];
        } else {
          newArr = [...this.checkedData, ...this.checkedCrudData];
        }
        let arr3 = unique(newArr);
        //let arr3 = Array.from(new Set(newArr))
        this.checkedCrudData = arr3;
      }
      this.checkedData = [];
      this.$refs.crud.clearSelection();
    },
    removeSelect(selectData, row) {
      this.removeData = selectData;
    },
    select(selectData, row) {
      if (!this.multiple) {
        if (selectData.length > 1) {
          let del_row = selectData.shift();
          this.$refs.crud.$refs.table.toggleRowSelection(del_row, false);
        }
      }
      this.checkedData = selectData;
    },
    cancel() {
      this.$emit("closeCallback");
    },
    deptClick(obj) {
      this.currentTreeId = obj.ID;
      this.$refs.crud.loadData();
    },
    loadData(form) {
      form.organizeID = this.currentTreeId;
      //this.$set(form,'WebSiteID',this.currentWebSiteID)
      getUserList(form).then((res) => {
        if (res.Code === 200) {
          if (res.Data) {
            this.tableData = res.Data.rows;
            this.pages.total = res.Data.total;
            this.$refs.crud.setCurrentRow();
          }
        } else {
          this.tableData = [];
        }
        this.tableOptions.loading = false;
      });
    },
    diaLogSubmit() {
      this.$emit("submit", this.checkedCrudData);
    },
    setTreeWidth(value) {
      this.treeWidth = value;
    },
  },
};
</script>
<style scoped  lang="scss">
.container {
  height: 400px;
  overflow: auto;
  width: 100%;
  display: flex;
  > div {
    border: 1px solid #d0d0d0;
    padding: 10px;
  }
  &-left {
    border-right: 0 !important;
  }
  &-middle {
    width: 500px;
    border-right: 0 !important;
  }
  &-right {
    width: 0;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserSelect.vue